<div class="popup-container">
  <ng-container [ngSwitch]="result.status">
    <ng-container *ngSwitchCase="EMasriVerificationStatus.LOADING">
      <ng-container *ngTemplateOutlet="popupScreeningTemplate; context: {
        icon: 'pop-load.png',
        title: 'Blacklist Screening',
        text: 'Sending screening request for ' + result.name + ' (ID #' + subscription.code + ')',
        loading: true
      }"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="EMasriVerificationStatus.ALLOWED">
      <ng-container *ngTemplateOutlet="popupScreeningTemplate; context: {
        icon: 'pop-verify.png',
        title: 'Screening Passed',
        text: 'The user is cleared and the subscription has been automatically approved.',
        result: 'Clean',
        status: 'Approved',
        name: result.name,
        showInfoBox: true
      }"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="EMasriVerificationStatus.NOT_ALLOWED">
      <ng-container *ngTemplateOutlet="popupScreeningTemplate; context: {
        icon: 'pop-error.png',
        title: 'Screening Failed',
        text: 'The user is blacklisted. The subscription has been automatically rejected.',
        result: 'Blacklisted',
        status: 'Rejected',
        name: result.name,
        showInfoBox: true
      }"></ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="EMasriVerificationStatus.NOT_FOUND">
      <ng-container *ngTemplateOutlet="popupScreeningTemplate; context: {
        icon: 'pop-send.png',
        title: 'Screening In Progress',
        text: 'User data was not found. A request has been submitted and the screening result is pending.',
        result: 'Data Not Found',
        status: 'Pending',
        name: result.name,
        showInfoBox: true
      }"></ng-container>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <ng-container *ngTemplateOutlet="popupScreeningTemplate; context: {
        icon: 'pop-error.png',
        title: 'Something is not correct',
        text: 'An error occurred during the screening process, try again later or call the support.'
      }"></ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-template #popupScreeningTemplate let-icon="icon" let-title="title" let-text="text"
             let-status="status" let-result="result" let-name="name"
             let-showInfoBox="showInfoBox" let-loading="loading">

  <div class="popup-body popup-screening-body">
    <div class="popup-screening-icon">
      <img [src]="'assets/images/images/' + icon" />
    </div>

    <div class="popup-title">{{ title }}</div>
    <div class="popup-text">{{ text }}</div>

    <ng-container *ngIf="showInfoBox">
      <div class="popup-info-box">
        <div class="popup-info-box-row">
          <div class="popup-info-box-label">Subscription #:</div>
          <div class="popup-info-box-value">{{ subscription.code }}</div>
        </div>
        <div class="popup-info-box-row" *ngIf="name">
          <div class="popup-info-box-label">User:</div>
          <div class="popup-info-box-value">{{ name }}</div>
        </div>
        <div class="popup-info-box-row" *ngIf="result">
          <div class="popup-info-box-label">Screening Result:</div>
          <div class="popup-info-box-value">{{ result }}</div>
        </div>
        <div class="popup-info-box-row" *ngIf="status">
          <div class="popup-info-box-label">Status:</div>
          <div class="popup-info-box-value">{{ status }}</div>
        </div>
      </div>
    </ng-container>

    <div class="popup-footer" *ngIf="!loading">
      <sxw-button theme="btn btn-large primary" (onClick)="close()" label="Close"></sxw-button>
    </div>
  </div>
</ng-template>

